export default {"src":"/_next/static/media/ir.de7d40f7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};